export default {
      id: "facebook-usage",
      viewBox: "0 0 7 16",
      url: __webpack_public_path__ + "icons-sprite.102705a.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }